import { CustomListItemId } from "@sp-crm/core";
import React from "react";
import { useCustomList } from "store/selectors/bridge";
import { PipelineVisibility } from "../../generated/graphql";
import { DraggableDashboardColumn } from "./column";
import type { PipelineConfig } from "./types";

interface PipelineInnerProps {
    config: PipelineConfig;
    searchCriteria: Record<string, unknown>;
}

export const PipelineInner: React.FC<PipelineInnerProps> = props => {
    const { config, searchCriteria } = props;
    const [highlightedEntities, setHighlightedEntities] = React.useState<string[]>([]);
    const [pendingEntities, setPendingEntities] = React.useState<string[]>([]);

    const { customList, itemHasCategory } = useCustomList(config.customListKey);

    const dragHandler = React.useCallback(
        async (
            entityId: string,
            oldStatusId: CustomListItemId,
            newStatusId: CustomListItemId,
        ) => {
            setHighlightedEntities(list => [...list, entityId]);
            setPendingEntities(list => [...list, entityId]);
            await config.onDragDrop(entityId, oldStatusId, newStatusId, searchCriteria);
            setPendingEntities(list => list.filter(id => id !== entityId));
            setTimeout(
                () => setHighlightedEntities(list => list.filter(id => id !== entityId)),
                1000,
            );
        },
        [setHighlightedEntities, setPendingEntities, config, searchCriteria],
    );

    if (!customList) {
        return null;
    }

    return (
        <div className="pipeline row main-body">
            {customList.items.map(item => {
                if (item.pipelineVisibility !== PipelineVisibility.Show) {
                    return null;
                }

                return (
                    <DraggableDashboardColumn
                        key={item.id}
                        id={item.id}
                        humanFriendly={item.name}
                        icon={item.icon}
                        token={item.key}
                        pipelinePrefix={
                            itemHasCategory(item.id, "Closed") ? "Recently " : ""
                        }
                        config={config}
                        dragHandler={dragHandler}
                        highlightedEntities={highlightedEntities}
                        pendingEntities={pendingEntities}
                        showAssignedTo={typeof searchCriteria.assignedUserId !== "string"}
                        searchCriteria={searchCriteria}
                    />
                );
            })}
        </div>
    );
};
